import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'ag-invitation-declined',
    templateUrl: './invitation-declined.component.html',
    styleUrls: ['./invitation-declined.component.scss'],
    standalone: false
})
export class InvitationDeclinedComponent implements OnInit 
{
    stationName = ""
    currentOwnerName = ""

    constructor(private route: ActivatedRoute)
    {
        
    }

    ngOnInit()
    {
        this.route.queryParams.subscribe(params => 
        {
            this.stationName = params.stationName
            this.currentOwnerName = params.currentOwnerName
        })
    }
}
